import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import {
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelContent,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle
} from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { CreditsComponent } from '../../../pages/credits/credits.component';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        CreditsComponent,
        MatIcon,
        MatTab,
        MatTabLabel,
        MatExpansionPanel,
        MatExpansionPanelContent,
        MatExpansionPanelTitle,
        MatExpansionPanelHeader,
        MatAccordion,
        MatTabGroup,
        MatCard,
        TranslocoModule,
        FlexLayoutModule,
        MatButtonModule
    ]
})
export class TermsOfUseComponent implements OnInit {
    panelOpenState = false;
    constructor(
        private _location: Location,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {}

    ngOnInit(): void {
        this._googleAnalyticsService.pageView('Terms of Use');
    }

    goBack() {
        this._location.back();
    }
}
